module.exports = __webpack_public_path__ + "img/security.a7450986.svg";